import { defineStore } from 'pinia';
import { Device } from "@nuxtjs/device/dist/runtime/types";
import { Method } from "~/enums";

export const useDeviceStore = defineStore("deviceStore", {
	state: () => ({
		device:  useLocalStorage('device', "" as string),
		deviceInfo: useLocalStorage('deviceInfo', null as Device | null),
		deviceCheckList: ["isMobile", "isDesktop"],
    defaultDeviceInfo: useLocalStorage("defaultDeviceInfo", null as any),
		appInfo: useLocalStorage('appInfo', null as any),
		deviceWidth: useLocalStorage('deviceWidth', null as number | null),
		deviceHeight: useLocalStorage("deviceHeight", null as number | null ),
		devicePixelRatio: useLocalStorage("devicePixelRatio", null as number | null) ,


		dpiObject: {
			dppx: 0,
			dpi: 0,
			orientation: 0,
			screenW: 0,
			screenH: 0,
			windowW: 0,
			windowH: 0,
			viewPortX: 0,
			viewPortY: 0,
			screenX: 0,
			screenY: 0
		}
	}),

	actions: {
		setDevice() {
			let deviceInfo = useDevice();

			// 앱 WebView로 접속한 경우: useDevice()는 UA/뷰포트 기준이라 isMobile이 false일 수 있음 → 앱 브릿지 존재 시 모바일로 보정
			if (typeof window !== "undefined") {
				const hasAndroidBridge = typeof (window as any).jsBridge !== "undefined";
				// iOS: messageHandlers.jsBridge는 객체({ postMessage })이므로 && 결과가 boolean이 아님 → 반드시 boolean으로 변환
				const hasIosBridge = Boolean(
					typeof (window as any).webkit !== "undefined" &&
						(window as any).webkit?.messageHandlers?.jsBridge
				);
				if (hasAndroidBridge || hasIosBridge) {
					deviceInfo = {
						...deviceInfo,
						isMobile: true,
						isAndroid: hasAndroidBridge,
						isIos: hasIosBridge,
						isDesktop: false,
					} as Device;
				}
			}

			this.deviceInfo = deviceInfo;
			this.defaultDeviceInfo = deviceInfo;
			let trueDevices: string[] = [];
			for (const [key, value] of Object.entries(deviceInfo)) {
				if (this.deviceCheckList.includes(key) && value === true) {
					trueDevices.push(key);
				}
			}

			this.device = trueDevices[0] ?? "";
			return deviceInfo;
		},
		async getAppInfo(appId: string) {
			const res = await useCustomFetch(`/api/v1/apps/${appId}`, { method: Method.GET });
			this.appInfo = res.data.value;
			return res.data.value;
		},
		async getDeviceSize(width: number, height: number, devicePixelRatio: number, dpi: number, screen: Screen){
			this.deviceWidth = width;
			this.deviceHeight = height;
			this.devicePixelRatio = height / width;

			if(devicePixelRatio !== 'undefined'){
				this.dpiObject.dppx = devicePixelRatio;
			} else {
				for(let i = 5; i >= 1; i = (i - 0.05).toFixed(2)){
					if (window.matchMedia("(-webkit-min-device-pixel-ratio: " + i + ")").matches 
							|| window.matchMedia("(min-resolution: " + i + "dppx)").matches) {
						this.dpiObject.dppx = i;
						break;
					}				
				}
			}

			this.dpiObject.dpi = dpi;
			
				if (typeof screen.orientation !== 'undefined') {
					this.dpiObject.orientation = screen.orientation.angle;
				} else {
					this.dpiObject.orientation = window.orientation;
				}

				
				this.dpiObject.screenW = Math.max(screen.width || 0);
				this.dpiObject.screenH = Math.max(screen.height || 0);
				this.dpiObject.windowW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
				this.dpiObject.windowH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		
				this.dpiObject.viewPortX = this.dpiObject.windowW * this.dpiObject.dppx;
				this.dpiObject.viewPortY = this.dpiObject.windowH * this.dpiObject.dppx;
				this.dpiObject.screenX = this.dpiObject.screenW * this.dpiObject.dppx;
				this.dpiObject.screenY = this.dpiObject.screenH * this.dpiObject.dppx;
		}
	},
});
